import axios from 'axios';
import {
  ADVANCE_UPLOAD_REQUEST,
  ADVANCE_UPLOAD_SUCCESS,
  ADVANCE_UPLOAD_FAIL,
  ADVANCE_LIST_REQUEST,
  ADVANCE_LIST_SUCCESS,
  ADVANCE_LIST_FAIL,
  ADVANCE_UPDATE_REQUEST,
  ADVANCE_UPDATE_SUCCESS,
  ADVANCE_UPDATE_FAIL,
  ADVANCE_DELETE_REQUEST,
  ADVANCE_DELETE_SUCCESS,
  ADVANCE_DELETE_FAIL,
  ATTENDANCE_UPLOAD_REQUEST,
  ATTENDANCE_UPLOAD_SUCCESS,
  ATTENDANCE_UPLOAD_FAIL,
  ATTENDANCE_LIST_REQUEST,
  ATTENDANCE_LIST_SUCCESS,
  ATTENDANCE_LIST_FAIL,
  ATTENDANCE_UPDATE_REQUEST,
  ATTENDANCE_UPDATE_SUCCESS,
  ATTENDANCE_UPDATE_FAIL,
  ATTENDANCE_DELETE_REQUEST,
  ATTENDANCE_DELETE_SUCCESS,
  ATTENDANCE_DELETE_FAIL,
  ATTENDANCE_STATS_REQUEST,
  ATTENDANCE_STATS_SUCCESS,
  ATTENDANCE_STATS_FAIL,
  BONUS_UPLOAD_REQUEST,
  BONUS_UPLOAD_SUCCESS,
  BONUS_UPLOAD_FAIL,
  BONUS_LIST_REQUEST,
  BONUS_LIST_SUCCESS,
  BONUS_LIST_FAIL,
  BONUS_UPDATE_REQUEST,
  BONUS_UPDATE_SUCCESS,
  BONUS_UPDATE_FAIL,
  BONUS_DELETE_REQUEST,
  BONUS_DELETE_SUCCESS,
  BONUS_DELETE_FAIL,
} from '../constants/masterConstants';

const baseUrl = process.env.REACT_APP_API_URL;

// ========== ADVANCE MASTER ACTIONS ==========

// Upload Advance Master Excel
export const uploadAdvanceExcel = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADVANCE_UPLOAD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(`${baseUrl}/advance-master/upload`, formData, config);

    dispatch({
      type: ADVANCE_UPLOAD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADVANCE_UPLOAD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Get Advance Records
export const listAdvanceRecords = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADVANCE_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const queryParams = new URLSearchParams(filters).toString();
    const { data } = await axios.get(`${baseUrl}/advance-master?${queryParams}`, config);

    dispatch({
      type: ADVANCE_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADVANCE_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Update Advance Record
export const updateAdvanceRecord = (id, updateData) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADVANCE_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`${baseUrl}/advance-master/${id}`, updateData, config);

    dispatch({
      type: ADVANCE_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ADVANCE_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Delete Advance Record
export const deleteAdvanceRecord = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADVANCE_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${baseUrl}/advance-master/${id}`, config);

    dispatch({
      type: ADVANCE_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: ADVANCE_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ========== ATTENDANCE MASTER ACTIONS ==========

// Upload Attendance Master Excel
export const uploadAttendanceExcel = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: ATTENDANCE_UPLOAD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(`${baseUrl}/attendance-master/upload`, formData, config);

    dispatch({
      type: ATTENDANCE_UPLOAD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ATTENDANCE_UPLOAD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Get Attendance Records
export const listAttendanceRecords = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: ATTENDANCE_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const queryParams = new URLSearchParams(filters).toString();
    const { data } = await axios.get(`${baseUrl}/attendance-master?${queryParams}`, config);

    dispatch({
      type: ATTENDANCE_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ATTENDANCE_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Update Attendance Record
export const updateAttendanceRecord = (id, updateData) => async (dispatch, getState) => {
  try {
    dispatch({ type: ATTENDANCE_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`${baseUrl}/attendance-master/${id}`, updateData, config);

    dispatch({
      type: ATTENDANCE_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ATTENDANCE_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Delete Attendance Record
export const deleteAttendanceRecord = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ATTENDANCE_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${baseUrl}/attendance-master/${id}`, config);

    dispatch({
      type: ATTENDANCE_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: ATTENDANCE_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Get Attendance Stats
export const getAttendanceStats = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: ATTENDANCE_STATS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const queryParams = new URLSearchParams(filters).toString();
    const { data } = await axios.get(`${baseUrl}/attendance-master/stats?${queryParams}`, config);

    dispatch({
      type: ATTENDANCE_STATS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ATTENDANCE_STATS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ========== BONUS MASTER ACTIONS ==========

// Upload Bonus Master Excel
export const uploadBonusExcel = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: BONUS_UPLOAD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(`${baseUrl}/bonus-master/upload`, formData, config);

    dispatch({
      type: BONUS_UPLOAD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: BONUS_UPLOAD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Get Bonus Records
export const listBonusRecords = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: BONUS_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const queryParams = new URLSearchParams(filters).toString();
    const { data } = await axios.get(`${baseUrl}/bonus-master?${queryParams}`, config);

    dispatch({
      type: BONUS_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: BONUS_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Update Bonus Record
export const updateBonusRecord = (id, updateData) => async (dispatch, getState) => {
  try {
    dispatch({ type: BONUS_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`${baseUrl}/bonus-master/${id}`, updateData, config);

    dispatch({
      type: BONUS_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: BONUS_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Delete Bonus Record
export const deleteBonusRecord = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: BONUS_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${baseUrl}/bonus-master/${id}`, config);

    dispatch({
      type: BONUS_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: BONUS_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
